import React from "react";
import Certification from "./certifications";
import Skills from "./skills";
import SoftSkills from "./softskill";
import LanguagesList from "./languageslist";
import "react-toastify/dist/ReactToastify.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-image-lightbox/style.css";
import "video.js/dist/video-js.css";
import "../../../../../assets/css/overridestyles.css";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { useHistory } from "react-router-dom";

const CandidateSkills = () => {

  const history=useHistory();

  const handleCancelButton = () => {
    history.push("/smartresume");
  };

  return (
    <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">
<div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <div className="profile-card-title">
                <h2 className="t-h2-font-sm">
                  <strong>
                    Add and rate your skills to highlight your strengths
                  </strong>
                </h2>
            </div>
            <div className="addexperience right mt-3 mb-3">
              <SoftSkills />
              <Skills />
              <LanguagesList />
              <Certification />
            </div>
            <TeamanicsButton className="mt-3" onClick={handleCancelButton}>
              Cancel
            </TeamanicsButton>
            <TeamanicsButton className="mt-3 ml-2" onClick={handleCancelButton}>
              Save
            </TeamanicsButton>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CandidateSkills;
